import gql from 'graphql-tag';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** DateTime */
  DateTime: any;
};

export type AnsweredConsultationsConsultationPagy = {
  __typename?: 'AnsweredConsultationsConsultationPagy';
  nodes: Array<Consultation>;
  pageInfo: Pagy;
};

export type Consultation = {
  __typename?: 'Consultation';
  age: Scalars['Int'];
  body: Scalars['String'];
  createdAt: Scalars['DateTime'];
  displayMessagesForConsulter?: Maybe<MessageConnection>;
  displayMessagesForDoctor?: Maybe<MessageConnection>;
  draftMessage?: Maybe<DraftMessage>;
  gender: Gender;
  id: Scalars['ID'];
  lastMessage?: Maybe<Message>;
  medicalHistories?: Maybe<MedicalHistoryConnection>;
  messages?: Maybe<MessageConnection>;
  symptoms?: Maybe<SymptomConnection>;
  targetType: ConsultationTarget;
  title: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};


export type ConsultationDisplayMessagesForConsulterArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


export type ConsultationDisplayMessagesForDoctorArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


export type ConsultationMedicalHistoriesArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


export type ConsultationMessagesArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


export type ConsultationSymptomsArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};

/** The connection type for Consultation. */
export type ConsultationConnection = {
  __typename?: 'ConsultationConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ConsultationEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Consultation>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type ConsultationEdge = {
  __typename?: 'ConsultationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<Consultation>;
};

export type ConsultationPagy = {
  __typename?: 'ConsultationPagy';
  nodes: Array<Consultation>;
  pageInfo: Pagy;
};

export enum ConsultationTarget {
  Myself = 'myself',
  Others = 'others'
}

export type Consulter = {
  __typename?: 'Consulter';
  consultations: ConsultationConnection;
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  email?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  progressConsultation?: Maybe<Consultation>;
};


export type ConsulterConsultationsArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};

/** Autogenerated input type of CreateConsultation */
export type CreateConsultationInput = {
  age: Scalars['Int'];
  targetType: ConsultationTarget;
  gender?: Maybe<Gender>;
  symptomIds: Array<Scalars['String']>;
  historyId: Scalars['String'];
  body: Scalars['String'];
  title: Scalars['String'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of CreateConsultation */
export type CreateConsultationPayload = {
  __typename?: 'CreateConsultationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  consultation?: Maybe<Consultation>;
};

/** Autogenerated input type of CreateConsulterMessage */
export type CreateConsulterMessageInput = {
  body: Scalars['String'];
  status: MessageStatus;
  consultationId: Scalars['ID'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of CreateConsulterMessage */
export type CreateConsulterMessagePayload = {
  __typename?: 'CreateConsulterMessagePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  message?: Maybe<Message>;
};

/** Autogenerated input type of CreateDoctorMessage */
export type CreateDoctorMessageInput = {
  body: Scalars['String'];
  status: MessageStatus;
  consultationId: Scalars['ID'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of CreateDoctorMessage */
export type CreateDoctorMessagePayload = {
  __typename?: 'CreateDoctorMessagePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  message?: Maybe<Message>;
};

/** Autogenerated input type of CreateDraftMessage */
export type CreateDraftMessageInput = {
  body: Scalars['String'];
  status: DraftMessageStatus;
  consultationId: Scalars['ID'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of CreateDraftMessage */
export type CreateDraftMessagePayload = {
  __typename?: 'CreateDraftMessagePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  draftMessage?: Maybe<DraftMessage>;
};


export type Doctor = {
  __typename?: 'Doctor';
  answeredConsultations: AnsweredConsultationsConsultationPagy;
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  email?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  unansweredConsultations: ConsultationConnection;
};


export type DoctorAnsweredConsultationsArgs = {
  page?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
};


export type DoctorUnansweredConsultationsArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};

export type DraftMessage = {
  __typename?: 'DraftMessage';
  body?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  status?: Maybe<DraftMessageStatus>;
};

export enum DraftMessageStatus {
  Draft = 'draft',
  Rejected = 'rejected'
}

export enum Gender {
  Male = 'male',
  Female = 'female'
}

export type MedicalHistory = {
  __typename?: 'MedicalHistory';
  body: Scalars['String'];
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
};

/** The connection type for MedicalHistory. */
export type MedicalHistoryConnection = {
  __typename?: 'MedicalHistoryConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<MedicalHistoryEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<MedicalHistory>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type MedicalHistoryEdge = {
  __typename?: 'MedicalHistoryEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<MedicalHistory>;
};

export type Message = {
  __typename?: 'Message';
  adminMessage: Scalars['Boolean'];
  body?: Maybe<Scalars['String']>;
  consulterMessage: Scalars['Boolean'];
  createdAt: Scalars['DateTime'];
  doctorMessage: Scalars['Boolean'];
  id: Scalars['ID'];
  status?: Maybe<MessageStatus>;
};

/** The connection type for Message. */
export type MessageConnection = {
  __typename?: 'MessageConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<MessageEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Message>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type MessageEdge = {
  __typename?: 'MessageEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<Message>;
};

export enum MessageStatus {
  Unchecked = 'unchecked',
  Checked = 'checked',
  Rejected = 'rejected'
}

export type Mutation = {
  __typename?: 'Mutation';
  createConsultation?: Maybe<CreateConsultationPayload>;
  createConsulterMessage?: Maybe<CreateConsulterMessagePayload>;
  createDoctorMessage?: Maybe<CreateDoctorMessagePayload>;
  createDraftMessage?: Maybe<CreateDraftMessagePayload>;
};


export type MutationCreateConsultationArgs = {
  input: CreateConsultationInput;
};


export type MutationCreateConsulterMessageArgs = {
  input: CreateConsulterMessageInput;
};


export type MutationCreateDoctorMessageArgs = {
  input: CreateDoctorMessageInput;
};


export type MutationCreateDraftMessageArgs = {
  input: CreateDraftMessageInput;
};

/** Autogenerated return type of OnMessageAdded */
export type OnMessageAddedPayload = {
  __typename?: 'OnMessageAddedPayload';
  message: Scalars['String'];
};

/** Information about pagination in a connection. */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']>;
};

export type Pagy = {
  __typename?: 'Pagy';
  /** 全体の件数 */
  count: Scalars['Int'];
  /** 現在の開始位置 */
  from: Scalars['Int'];
  /** 終端のページ番号 */
  last: Scalars['Int'];
  /** 次のページ番号 */
  next?: Maybe<Scalars['Int']>;
  /** 現在のページ番号 */
  page: Scalars['Int'];
  /** 全体のページ数 */
  pages: Scalars['Int'];
  /** 前のページ番号 */
  prev?: Maybe<Scalars['Int']>;
  /** 現在の終了位置 */
  to: Scalars['Int'];
};

export type Query = {
  __typename?: 'Query';
  consultation?: Maybe<Consultation>;
  consultations?: Maybe<ConsultationPagy>;
  currentConsulter?: Maybe<Consulter>;
  currentDoctor?: Maybe<Doctor>;
  medicalHistories?: Maybe<MedicalHistoryConnection>;
  medicalHistory?: Maybe<MedicalHistory>;
  symptoms?: Maybe<SymptomConnection>;
};


export type QueryConsultationArgs = {
  id: Scalars['ID'];
};


export type QueryConsultationsArgs = {
  page?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
};


export type QueryMedicalHistoriesArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


export type QueryMedicalHistoryArgs = {
  id?: Maybe<Scalars['ID']>;
};


export type QuerySymptomsArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};

export type Subscription = {
  __typename?: 'Subscription';
  onMessageAdded: OnMessageAddedPayload;
};

export type Symptom = {
  __typename?: 'Symptom';
  createdAt: Scalars['DateTime'];
  description: Scalars['String'];
  id: Scalars['ID'];
};

/** The connection type for Symptom. */
export type SymptomConnection = {
  __typename?: 'SymptomConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<SymptomEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Symptom>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type SymptomEdge = {
  __typename?: 'SymptomEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<Symptom>;
};

export type MessageItemsFragment = (
  { __typename?: 'Message' }
  & Pick<Message, 'id' | 'body' | 'createdAt' | 'consulterMessage' | 'doctorMessage' | 'adminMessage' | 'status'>
);

export type CreateConsultationMutationVariables = Exact<{
  input: CreateConsultationInput;
}>;


export type CreateConsultationMutation = (
  { __typename?: 'Mutation' }
  & { createConsultation?: Maybe<(
    { __typename?: 'CreateConsultationPayload' }
    & { consultation?: Maybe<(
      { __typename?: 'Consultation' }
      & Pick<Consultation, 'id'>
    )> }
  )> }
);

export type CreateConsulterMessageMutationVariables = Exact<{
  input: CreateConsulterMessageInput;
}>;


export type CreateConsulterMessageMutation = (
  { __typename?: 'Mutation' }
  & { createConsulterMessage?: Maybe<(
    { __typename?: 'CreateConsulterMessagePayload' }
    & { message?: Maybe<(
      { __typename?: 'Message' }
      & MessageItemsFragment
    )> }
  )> }
);

export type CreateDoctorMessageMutationVariables = Exact<{
  input: CreateDoctorMessageInput;
}>;


export type CreateDoctorMessageMutation = (
  { __typename?: 'Mutation' }
  & { createDoctorMessage?: Maybe<(
    { __typename?: 'CreateDoctorMessagePayload' }
    & { message?: Maybe<(
      { __typename?: 'Message' }
      & MessageItemsFragment
    )> }
  )> }
);

export type CreateDraftMessageMutationVariables = Exact<{
  input: CreateDraftMessageInput;
}>;


export type CreateDraftMessageMutation = (
  { __typename?: 'Mutation' }
  & { createDraftMessage?: Maybe<(
    { __typename?: 'CreateDraftMessagePayload' }
    & { draftMessage?: Maybe<(
      { __typename?: 'DraftMessage' }
      & Pick<DraftMessage, 'id' | 'body' | 'status'>
    )> }
  )> }
);

export type ConsultationQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ConsultationQuery = (
  { __typename?: 'Query' }
  & { consultation?: Maybe<(
    { __typename?: 'Consultation' }
    & Pick<Consultation, 'id' | 'gender' | 'targetType' | 'age' | 'title' | 'body' | 'createdAt'>
    & { lastMessage?: Maybe<(
      { __typename?: 'Message' }
      & MessageItemsFragment
    )>, draftMessage?: Maybe<(
      { __typename?: 'DraftMessage' }
      & Pick<DraftMessage, 'id' | 'body' | 'status'>
    )>, symptoms?: Maybe<(
      { __typename?: 'SymptomConnection' }
      & { nodes?: Maybe<Array<Maybe<(
        { __typename?: 'Symptom' }
        & Pick<Symptom, 'id' | 'description'>
      )>>> }
    )>, medicalHistories?: Maybe<(
      { __typename?: 'MedicalHistoryConnection' }
      & { nodes?: Maybe<Array<Maybe<(
        { __typename?: 'MedicalHistory' }
        & Pick<MedicalHistory, 'id' | 'body'>
      )>>> }
    )>, messages?: Maybe<(
      { __typename?: 'MessageConnection' }
      & { nodes?: Maybe<Array<Maybe<(
        { __typename?: 'Message' }
        & MessageItemsFragment
      )>>> }
    )>, displayMessagesForConsulter?: Maybe<(
      { __typename?: 'MessageConnection' }
      & { nodes?: Maybe<Array<Maybe<(
        { __typename?: 'Message' }
        & MessageItemsFragment
      )>>> }
    )>, displayMessagesForDoctor?: Maybe<(
      { __typename?: 'MessageConnection' }
      & { nodes?: Maybe<Array<Maybe<(
        { __typename?: 'Message' }
        & MessageItemsFragment
      )>>> }
    )> }
  )> }
);

export type ConsultationForClientQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ConsultationForClientQuery = (
  { __typename?: 'Query' }
  & { consultation?: Maybe<(
    { __typename?: 'Consultation' }
    & Pick<Consultation, 'id' | 'gender' | 'age' | 'title' | 'body' | 'createdAt'>
    & { displayMessagesForConsulter?: Maybe<(
      { __typename?: 'MessageConnection' }
      & { nodes?: Maybe<Array<Maybe<(
        { __typename?: 'Message' }
        & MessageItemsFragment
      )>>> }
    )> }
  )> }
);

export type ConsultationsQueryVariables = Exact<{
  page?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
}>;


export type ConsultationsQuery = (
  { __typename?: 'Query' }
  & { consultations?: Maybe<(
    { __typename?: 'ConsultationPagy' }
    & { nodes: Array<(
      { __typename?: 'Consultation' }
      & Pick<Consultation, 'id' | 'gender' | 'age' | 'title' | 'body' | 'createdAt'>
    )>, pageInfo: (
      { __typename?: 'Pagy' }
      & Pick<Pagy, 'count' | 'next' | 'prev' | 'from' | 'to' | 'last' | 'page' | 'pages'>
    ) }
  )> }
);

export type CurrentConsulterQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentConsulterQuery = (
  { __typename?: 'Query' }
  & { currentConsulter?: Maybe<(
    { __typename?: 'Consulter' }
    & Pick<Consulter, 'id' | 'email'>
    & { progressConsultation?: Maybe<(
      { __typename?: 'Consultation' }
      & Pick<Consultation, 'id' | 'body'>
    )> }
  )> }
);

export type CurrentDoctorQueryVariables = Exact<{
  page?: Maybe<Scalars['Int']>;
}>;


export type CurrentDoctorQuery = (
  { __typename?: 'Query' }
  & { currentDoctor?: Maybe<(
    { __typename?: 'Doctor' }
    & Pick<Doctor, 'id' | 'email' | 'deletedAt'>
    & { answeredConsultations: (
      { __typename?: 'AnsweredConsultationsConsultationPagy' }
      & { nodes: Array<(
        { __typename?: 'Consultation' }
        & Pick<Consultation, 'id' | 'age' | 'gender' | 'targetType' | 'title' | 'body' | 'createdAt'>
        & { medicalHistories?: Maybe<(
          { __typename?: 'MedicalHistoryConnection' }
          & { nodes?: Maybe<Array<Maybe<(
            { __typename?: 'MedicalHistory' }
            & Pick<MedicalHistory, 'id' | 'body'>
          )>>> }
        )>, lastMessage?: Maybe<(
          { __typename?: 'Message' }
          & MessageItemsFragment
        )> }
      )>, pageInfo: (
        { __typename?: 'Pagy' }
        & Pick<Pagy, 'count' | 'next' | 'prev' | 'from' | 'to' | 'last' | 'page' | 'pages'>
      ) }
    ), unansweredConsultations: (
      { __typename?: 'ConsultationConnection' }
      & { nodes?: Maybe<Array<Maybe<(
        { __typename?: 'Consultation' }
        & Pick<Consultation, 'id' | 'age' | 'gender' | 'targetType' | 'title' | 'body' | 'createdAt'>
        & { medicalHistories?: Maybe<(
          { __typename?: 'MedicalHistoryConnection' }
          & { nodes?: Maybe<Array<Maybe<(
            { __typename?: 'MedicalHistory' }
            & Pick<MedicalHistory, 'id' | 'body'>
          )>>> }
        )>, lastMessage?: Maybe<(
          { __typename?: 'Message' }
          & MessageItemsFragment
        )> }
      )>>> }
    ) }
  )> }
);

export type MedicalHistoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type MedicalHistoriesQuery = (
  { __typename?: 'Query' }
  & { medicalHistories?: Maybe<(
    { __typename?: 'MedicalHistoryConnection' }
    & { nodes?: Maybe<Array<Maybe<(
      { __typename?: 'MedicalHistory' }
      & Pick<MedicalHistory, 'id' | 'body' | 'createdAt'>
    )>>> }
  )> }
);

export type MedicalHistoryQueryVariables = Exact<{
  id?: Maybe<Scalars['ID']>;
}>;


export type MedicalHistoryQuery = (
  { __typename?: 'Query' }
  & { medicalHistory?: Maybe<(
    { __typename?: 'MedicalHistory' }
    & Pick<MedicalHistory, 'id' | 'body' | 'createdAt'>
  )> }
);

export type SymptomsQueryVariables = Exact<{ [key: string]: never; }>;


export type SymptomsQuery = (
  { __typename?: 'Query' }
  & { symptoms?: Maybe<(
    { __typename?: 'SymptomConnection' }
    & { nodes?: Maybe<Array<Maybe<(
      { __typename?: 'Symptom' }
      & Pick<Symptom, 'id' | 'description' | 'createdAt'>
    )>>> }
  )> }
);

export type OnMessageAddedSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type OnMessageAddedSubscription = (
  { __typename?: 'Subscription' }
  & { onMessageAdded: (
    { __typename?: 'OnMessageAddedPayload' }
    & Pick<OnMessageAddedPayload, 'message'>
  ) }
);

export const MessageItemsFragmentDoc = gql`
    fragment MessageItems on Message {
  id
  body
  createdAt
  consulterMessage
  doctorMessage
  adminMessage
  status
}
    `;
export const CreateConsultationDocument = gql`
    mutation createConsultation($input: CreateConsultationInput!) {
  createConsultation(input: $input) {
    consultation {
      id
    }
  }
}
    `;
export type CreateConsultationMutationFn = Apollo.MutationFunction<CreateConsultationMutation, CreateConsultationMutationVariables>;

/**
 * __useCreateConsultationMutation__
 *
 * To run a mutation, you first call `useCreateConsultationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateConsultationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createConsultationMutation, { data, loading, error }] = useCreateConsultationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateConsultationMutation(baseOptions?: Apollo.MutationHookOptions<CreateConsultationMutation, CreateConsultationMutationVariables>) {
        return Apollo.useMutation<CreateConsultationMutation, CreateConsultationMutationVariables>(CreateConsultationDocument, baseOptions);
      }
export type CreateConsultationMutationHookResult = ReturnType<typeof useCreateConsultationMutation>;
export type CreateConsultationMutationResult = Apollo.MutationResult<CreateConsultationMutation>;
export type CreateConsultationMutationOptions = Apollo.BaseMutationOptions<CreateConsultationMutation, CreateConsultationMutationVariables>;
export const CreateConsulterMessageDocument = gql`
    mutation createConsulterMessage($input: CreateConsulterMessageInput!) {
  createConsulterMessage(input: $input) {
    message {
      ...MessageItems
    }
  }
}
    ${MessageItemsFragmentDoc}`;
export type CreateConsulterMessageMutationFn = Apollo.MutationFunction<CreateConsulterMessageMutation, CreateConsulterMessageMutationVariables>;

/**
 * __useCreateConsulterMessageMutation__
 *
 * To run a mutation, you first call `useCreateConsulterMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateConsulterMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createConsulterMessageMutation, { data, loading, error }] = useCreateConsulterMessageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateConsulterMessageMutation(baseOptions?: Apollo.MutationHookOptions<CreateConsulterMessageMutation, CreateConsulterMessageMutationVariables>) {
        return Apollo.useMutation<CreateConsulterMessageMutation, CreateConsulterMessageMutationVariables>(CreateConsulterMessageDocument, baseOptions);
      }
export type CreateConsulterMessageMutationHookResult = ReturnType<typeof useCreateConsulterMessageMutation>;
export type CreateConsulterMessageMutationResult = Apollo.MutationResult<CreateConsulterMessageMutation>;
export type CreateConsulterMessageMutationOptions = Apollo.BaseMutationOptions<CreateConsulterMessageMutation, CreateConsulterMessageMutationVariables>;
export const CreateDoctorMessageDocument = gql`
    mutation createDoctorMessage($input: CreateDoctorMessageInput!) {
  createDoctorMessage(input: $input) {
    message {
      ...MessageItems
    }
  }
}
    ${MessageItemsFragmentDoc}`;
export type CreateDoctorMessageMutationFn = Apollo.MutationFunction<CreateDoctorMessageMutation, CreateDoctorMessageMutationVariables>;

/**
 * __useCreateDoctorMessageMutation__
 *
 * To run a mutation, you first call `useCreateDoctorMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDoctorMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDoctorMessageMutation, { data, loading, error }] = useCreateDoctorMessageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateDoctorMessageMutation(baseOptions?: Apollo.MutationHookOptions<CreateDoctorMessageMutation, CreateDoctorMessageMutationVariables>) {
        return Apollo.useMutation<CreateDoctorMessageMutation, CreateDoctorMessageMutationVariables>(CreateDoctorMessageDocument, baseOptions);
      }
export type CreateDoctorMessageMutationHookResult = ReturnType<typeof useCreateDoctorMessageMutation>;
export type CreateDoctorMessageMutationResult = Apollo.MutationResult<CreateDoctorMessageMutation>;
export type CreateDoctorMessageMutationOptions = Apollo.BaseMutationOptions<CreateDoctorMessageMutation, CreateDoctorMessageMutationVariables>;
export const CreateDraftMessageDocument = gql`
    mutation createDraftMessage($input: CreateDraftMessageInput!) {
  createDraftMessage(input: $input) {
    draftMessage {
      id
      body
      status
    }
  }
}
    `;
export type CreateDraftMessageMutationFn = Apollo.MutationFunction<CreateDraftMessageMutation, CreateDraftMessageMutationVariables>;

/**
 * __useCreateDraftMessageMutation__
 *
 * To run a mutation, you first call `useCreateDraftMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDraftMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDraftMessageMutation, { data, loading, error }] = useCreateDraftMessageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateDraftMessageMutation(baseOptions?: Apollo.MutationHookOptions<CreateDraftMessageMutation, CreateDraftMessageMutationVariables>) {
        return Apollo.useMutation<CreateDraftMessageMutation, CreateDraftMessageMutationVariables>(CreateDraftMessageDocument, baseOptions);
      }
export type CreateDraftMessageMutationHookResult = ReturnType<typeof useCreateDraftMessageMutation>;
export type CreateDraftMessageMutationResult = Apollo.MutationResult<CreateDraftMessageMutation>;
export type CreateDraftMessageMutationOptions = Apollo.BaseMutationOptions<CreateDraftMessageMutation, CreateDraftMessageMutationVariables>;
export const ConsultationDocument = gql`
    query consultation($id: ID!) {
  consultation(id: $id) {
    id
    gender
    targetType
    age
    title
    body
    createdAt
    lastMessage {
      ...MessageItems
    }
    draftMessage {
      id
      body
      status
    }
    symptoms {
      nodes {
        id
        description
      }
    }
    medicalHistories {
      nodes {
        id
        body
      }
    }
    messages {
      nodes {
        ...MessageItems
      }
    }
    displayMessagesForConsulter {
      nodes {
        ...MessageItems
      }
    }
    displayMessagesForDoctor {
      nodes {
        ...MessageItems
      }
    }
  }
}
    ${MessageItemsFragmentDoc}`;

/**
 * __useConsultationQuery__
 *
 * To run a query within a React component, call `useConsultationQuery` and pass it any options that fit your needs.
 * When your component renders, `useConsultationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConsultationQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useConsultationQuery(baseOptions?: Apollo.QueryHookOptions<ConsultationQuery, ConsultationQueryVariables>) {
        return Apollo.useQuery<ConsultationQuery, ConsultationQueryVariables>(ConsultationDocument, baseOptions);
      }
export function useConsultationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ConsultationQuery, ConsultationQueryVariables>) {
          return Apollo.useLazyQuery<ConsultationQuery, ConsultationQueryVariables>(ConsultationDocument, baseOptions);
        }
export type ConsultationQueryHookResult = ReturnType<typeof useConsultationQuery>;
export type ConsultationLazyQueryHookResult = ReturnType<typeof useConsultationLazyQuery>;
export type ConsultationQueryResult = Apollo.QueryResult<ConsultationQuery, ConsultationQueryVariables>;
export function refetchConsultationQuery(variables?: ConsultationQueryVariables) {
      return { query: ConsultationDocument, variables: variables }
    }
export const ConsultationForClientDocument = gql`
    query consultationForClient($id: ID!) {
  consultation(id: $id) {
    id
    gender
    age
    title
    body
    createdAt
    displayMessagesForConsulter {
      nodes {
        ...MessageItems
      }
    }
  }
}
    ${MessageItemsFragmentDoc}`;

/**
 * __useConsultationForClientQuery__
 *
 * To run a query within a React component, call `useConsultationForClientQuery` and pass it any options that fit your needs.
 * When your component renders, `useConsultationForClientQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConsultationForClientQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useConsultationForClientQuery(baseOptions?: Apollo.QueryHookOptions<ConsultationForClientQuery, ConsultationForClientQueryVariables>) {
        return Apollo.useQuery<ConsultationForClientQuery, ConsultationForClientQueryVariables>(ConsultationForClientDocument, baseOptions);
      }
export function useConsultationForClientLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ConsultationForClientQuery, ConsultationForClientQueryVariables>) {
          return Apollo.useLazyQuery<ConsultationForClientQuery, ConsultationForClientQueryVariables>(ConsultationForClientDocument, baseOptions);
        }
export type ConsultationForClientQueryHookResult = ReturnType<typeof useConsultationForClientQuery>;
export type ConsultationForClientLazyQueryHookResult = ReturnType<typeof useConsultationForClientLazyQuery>;
export type ConsultationForClientQueryResult = Apollo.QueryResult<ConsultationForClientQuery, ConsultationForClientQueryVariables>;
export function refetchConsultationForClientQuery(variables?: ConsultationForClientQueryVariables) {
      return { query: ConsultationForClientDocument, variables: variables }
    }
export const ConsultationsDocument = gql`
    query consultations($page: Int, $limit: Int) {
  consultations(page: $page, limit: $limit) {
    nodes {
      id
      gender
      age
      title
      body
      createdAt
    }
    pageInfo {
      count
      next
      prev
      from
      to
      last
      page
      pages
    }
  }
}
    `;

/**
 * __useConsultationsQuery__
 *
 * To run a query within a React component, call `useConsultationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useConsultationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConsultationsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useConsultationsQuery(baseOptions?: Apollo.QueryHookOptions<ConsultationsQuery, ConsultationsQueryVariables>) {
        return Apollo.useQuery<ConsultationsQuery, ConsultationsQueryVariables>(ConsultationsDocument, baseOptions);
      }
export function useConsultationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ConsultationsQuery, ConsultationsQueryVariables>) {
          return Apollo.useLazyQuery<ConsultationsQuery, ConsultationsQueryVariables>(ConsultationsDocument, baseOptions);
        }
export type ConsultationsQueryHookResult = ReturnType<typeof useConsultationsQuery>;
export type ConsultationsLazyQueryHookResult = ReturnType<typeof useConsultationsLazyQuery>;
export type ConsultationsQueryResult = Apollo.QueryResult<ConsultationsQuery, ConsultationsQueryVariables>;
export function refetchConsultationsQuery(variables?: ConsultationsQueryVariables) {
      return { query: ConsultationsDocument, variables: variables }
    }
export const CurrentConsulterDocument = gql`
    query currentConsulter {
  currentConsulter {
    id
    email
    progressConsultation {
      id
      body
    }
  }
}
    `;

/**
 * __useCurrentConsulterQuery__
 *
 * To run a query within a React component, call `useCurrentConsulterQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentConsulterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentConsulterQuery({
 *   variables: {
 *   },
 * });
 */
export function useCurrentConsulterQuery(baseOptions?: Apollo.QueryHookOptions<CurrentConsulterQuery, CurrentConsulterQueryVariables>) {
        return Apollo.useQuery<CurrentConsulterQuery, CurrentConsulterQueryVariables>(CurrentConsulterDocument, baseOptions);
      }
export function useCurrentConsulterLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurrentConsulterQuery, CurrentConsulterQueryVariables>) {
          return Apollo.useLazyQuery<CurrentConsulterQuery, CurrentConsulterQueryVariables>(CurrentConsulterDocument, baseOptions);
        }
export type CurrentConsulterQueryHookResult = ReturnType<typeof useCurrentConsulterQuery>;
export type CurrentConsulterLazyQueryHookResult = ReturnType<typeof useCurrentConsulterLazyQuery>;
export type CurrentConsulterQueryResult = Apollo.QueryResult<CurrentConsulterQuery, CurrentConsulterQueryVariables>;
export function refetchCurrentConsulterQuery(variables?: CurrentConsulterQueryVariables) {
      return { query: CurrentConsulterDocument, variables: variables }
    }
export const CurrentDoctorDocument = gql`
    query currentDoctor($page: Int) {
  currentDoctor {
    id
    email
    deletedAt
    answeredConsultations(page: $page) {
      nodes {
        id
        age
        gender
        targetType
        title
        body
        createdAt
        medicalHistories {
          nodes {
            id
            body
          }
        }
        lastMessage {
          ...MessageItems
        }
      }
      pageInfo {
        count
        next
        prev
        from
        to
        last
        page
        pages
      }
    }
    unansweredConsultations {
      nodes {
        id
        age
        gender
        targetType
        title
        body
        createdAt
        medicalHistories {
          nodes {
            id
            body
          }
        }
        lastMessage {
          ...MessageItems
        }
      }
    }
  }
}
    ${MessageItemsFragmentDoc}`;

/**
 * __useCurrentDoctorQuery__
 *
 * To run a query within a React component, call `useCurrentDoctorQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentDoctorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentDoctorQuery({
 *   variables: {
 *      page: // value for 'page'
 *   },
 * });
 */
export function useCurrentDoctorQuery(baseOptions?: Apollo.QueryHookOptions<CurrentDoctorQuery, CurrentDoctorQueryVariables>) {
        return Apollo.useQuery<CurrentDoctorQuery, CurrentDoctorQueryVariables>(CurrentDoctorDocument, baseOptions);
      }
export function useCurrentDoctorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurrentDoctorQuery, CurrentDoctorQueryVariables>) {
          return Apollo.useLazyQuery<CurrentDoctorQuery, CurrentDoctorQueryVariables>(CurrentDoctorDocument, baseOptions);
        }
export type CurrentDoctorQueryHookResult = ReturnType<typeof useCurrentDoctorQuery>;
export type CurrentDoctorLazyQueryHookResult = ReturnType<typeof useCurrentDoctorLazyQuery>;
export type CurrentDoctorQueryResult = Apollo.QueryResult<CurrentDoctorQuery, CurrentDoctorQueryVariables>;
export function refetchCurrentDoctorQuery(variables?: CurrentDoctorQueryVariables) {
      return { query: CurrentDoctorDocument, variables: variables }
    }
export const MedicalHistoriesDocument = gql`
    query medicalHistories {
  medicalHistories {
    nodes {
      id
      body
      createdAt
    }
  }
}
    `;

/**
 * __useMedicalHistoriesQuery__
 *
 * To run a query within a React component, call `useMedicalHistoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useMedicalHistoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMedicalHistoriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useMedicalHistoriesQuery(baseOptions?: Apollo.QueryHookOptions<MedicalHistoriesQuery, MedicalHistoriesQueryVariables>) {
        return Apollo.useQuery<MedicalHistoriesQuery, MedicalHistoriesQueryVariables>(MedicalHistoriesDocument, baseOptions);
      }
export function useMedicalHistoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MedicalHistoriesQuery, MedicalHistoriesQueryVariables>) {
          return Apollo.useLazyQuery<MedicalHistoriesQuery, MedicalHistoriesQueryVariables>(MedicalHistoriesDocument, baseOptions);
        }
export type MedicalHistoriesQueryHookResult = ReturnType<typeof useMedicalHistoriesQuery>;
export type MedicalHistoriesLazyQueryHookResult = ReturnType<typeof useMedicalHistoriesLazyQuery>;
export type MedicalHistoriesQueryResult = Apollo.QueryResult<MedicalHistoriesQuery, MedicalHistoriesQueryVariables>;
export function refetchMedicalHistoriesQuery(variables?: MedicalHistoriesQueryVariables) {
      return { query: MedicalHistoriesDocument, variables: variables }
    }
export const MedicalHistoryDocument = gql`
    query medicalHistory($id: ID) {
  medicalHistory(id: $id) {
    id
    body
    createdAt
  }
}
    `;

/**
 * __useMedicalHistoryQuery__
 *
 * To run a query within a React component, call `useMedicalHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useMedicalHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMedicalHistoryQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMedicalHistoryQuery(baseOptions?: Apollo.QueryHookOptions<MedicalHistoryQuery, MedicalHistoryQueryVariables>) {
        return Apollo.useQuery<MedicalHistoryQuery, MedicalHistoryQueryVariables>(MedicalHistoryDocument, baseOptions);
      }
export function useMedicalHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MedicalHistoryQuery, MedicalHistoryQueryVariables>) {
          return Apollo.useLazyQuery<MedicalHistoryQuery, MedicalHistoryQueryVariables>(MedicalHistoryDocument, baseOptions);
        }
export type MedicalHistoryQueryHookResult = ReturnType<typeof useMedicalHistoryQuery>;
export type MedicalHistoryLazyQueryHookResult = ReturnType<typeof useMedicalHistoryLazyQuery>;
export type MedicalHistoryQueryResult = Apollo.QueryResult<MedicalHistoryQuery, MedicalHistoryQueryVariables>;
export function refetchMedicalHistoryQuery(variables?: MedicalHistoryQueryVariables) {
      return { query: MedicalHistoryDocument, variables: variables }
    }
export const SymptomsDocument = gql`
    query symptoms {
  symptoms {
    nodes {
      id
      description
      createdAt
    }
  }
}
    `;

/**
 * __useSymptomsQuery__
 *
 * To run a query within a React component, call `useSymptomsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSymptomsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSymptomsQuery({
 *   variables: {
 *   },
 * });
 */
export function useSymptomsQuery(baseOptions?: Apollo.QueryHookOptions<SymptomsQuery, SymptomsQueryVariables>) {
        return Apollo.useQuery<SymptomsQuery, SymptomsQueryVariables>(SymptomsDocument, baseOptions);
      }
export function useSymptomsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SymptomsQuery, SymptomsQueryVariables>) {
          return Apollo.useLazyQuery<SymptomsQuery, SymptomsQueryVariables>(SymptomsDocument, baseOptions);
        }
export type SymptomsQueryHookResult = ReturnType<typeof useSymptomsQuery>;
export type SymptomsLazyQueryHookResult = ReturnType<typeof useSymptomsLazyQuery>;
export type SymptomsQueryResult = Apollo.QueryResult<SymptomsQuery, SymptomsQueryVariables>;
export function refetchSymptomsQuery(variables?: SymptomsQueryVariables) {
      return { query: SymptomsDocument, variables: variables }
    }
export const OnMessageAddedDocument = gql`
    subscription onMessageAdded {
  onMessageAdded {
    message
  }
}
    `;

/**
 * __useOnMessageAddedSubscription__
 *
 * To run a query within a React component, call `useOnMessageAddedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnMessageAddedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnMessageAddedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useOnMessageAddedSubscription(baseOptions?: Apollo.SubscriptionHookOptions<OnMessageAddedSubscription, OnMessageAddedSubscriptionVariables>) {
        return Apollo.useSubscription<OnMessageAddedSubscription, OnMessageAddedSubscriptionVariables>(OnMessageAddedDocument, baseOptions);
      }
export type OnMessageAddedSubscriptionHookResult = ReturnType<typeof useOnMessageAddedSubscription>;
export type OnMessageAddedSubscriptionResult = Apollo.SubscriptionResult<OnMessageAddedSubscription>;